<template>
    <section :id="`element-${settings.id}`" class="elle-page-hero" :class="classes" data-is-hero>
        <div class="elle-page-hero--wrapper" :style="{ backgroundColor: settings?.color }">
            <div class="grid12 center-v">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                        :headline-type="props.settings?.wrapped ? 'sm' : ''"
                    >
                        <template #additional>
                            <div v-if="settings?.description" class="content typography" v-html="props.settings?.description" />
                        </template>
                    </UiHeadline>

                    <UiLink
                        v-if="settings?.linkUrl?.length && settings?.linkUrl[0].linkUrl !== null"
                        :link="settings?.linkUrl[0]"
                        :style="'transparent w-border'"
                    />
                </div>
                <div class="r-col">
                    <UiMediaWithVideo :media="settings?.media" :video="settings?.video" wrapper-class="w-ratio" image-classes="responsive full" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const classes = computed(() => {
    const classes = [];
    if (props.settings?.wrapped) classes.push('wrapped');
    if (props.settings?.fullScreen) classes.push('f-screen');
    if (props.settings?.removeExtraSpace) classes.push('f-remove-space');
    return classes;
});
</script>
